// MATERIAL UI
import Box from "@mui/material/Box";

// ICONS
import CircularProgress from "@mui/material/CircularProgress";

interface ILoadingSpinner {
  size: number;
  color?: string;
}

export const LoadingSpinner = ({ size, color = "#FC4C4C" }: ILoadingSpinner): JSX.Element => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress size={size} sx={{ color }} />
    </Box>
  );
};
